import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 0 auto;
	padding: 32px 0 0;
`;

export const Separator = styled.div`
	height: 20px;

	@media (max-width: 992px) {
		height: 60px;
	}
`;

export const CardWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-column-gap: 16px;
	grid-row-gap: 16px;

	@media (max-width: 992px) {
		grid-template-columns: repeat(2, 1fr);
	}
`;
